import { useRecoilValue, useSetRecoilState } from "recoil";
import { loginState } from "../../stores/loginState";
import { useMutation } from "react-query";
import { HandexInstance, HanjinInstance, KpcInstance, LogenInstance, LotteInstance } from "../instance";
import { monthTotalState } from "../../stores/dashboard/monthTotalState";
import { isKpcCompany, normalizeKpcChartData } from "../../utils/kpc";

// 고객사별 API 인스턴스 선택 함수
const getApiInstance = (company) => {
  const instances = {
    LOGEN: LogenInstance,
    LOTTE: LotteInstance,
    HANJIN: HanjinInstance,
    HANDEX: HandexInstance,
    KPC: KpcInstance,
  };
  return instances[company] || null;
};

// TODO 월간 데이터 조회 API
export const useGetMonthChart = (setMonthData) => {
  const login = useRecoilValue(loginState); // 로그인 전역변수
  const setMonthTotal = useSetRecoilState(monthTotalState); // 월간 데이터

  // API 요청 함수
  const fetchData = async () => {
    const apiInstance = getApiInstance(login.company);
    if (!apiInstance) throw new Error("Invalid company");

    return apiInstance.post("/boardTotal", {
      api: "month",
      // KPC는 쿠키 세션의 점소를 사용한다.
      data: [isKpcCompany(login.company) ? {} : { bran_cd: login.branchCode }],
    });
  };

  return useMutation("getMonthChart", fetchData, {
    onSuccess: (data) => {
      if (data.result === "00") {
        // KPC는 업무별 건수를 별도 필드로 반환하므로 차트 공통 구조로 변환한다.
        const chartData = isKpcCompany(login.company)
          ? normalizeKpcChartData(data.data)
          : data.data;
        setMonthData(chartData);
        const totalSum = chartData.reduce((totalSum, item) => {
          const itemSum = Array.isArray(item.count)
            ? item.count.reduce((sum, countStr) => sum + parseInt(countStr, 10), 0)
            : parseInt(item.count, 10);
          return totalSum + itemSum;
        }, 0);
        setMonthTotal(totalSum);
      }
    },
    onError: (error) => {
      console.error(error);
    },
  });
};
